// removed by extract-text-webpack-plugin
module.exports = {"Project":"src-components-Project----Project-module---Project---2miAy","Head":"src-components-Project----Project-module---Head---23TP7","Skills":"src-components-Project----Project-module---Skills---Umb25","Title":"src-components-Project----Project-module---Title---2WGHd","Link":"src-components-Project----Project-module---Link---12_7r","date":"src-components-Project----Project-module---date---HjpJn"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Project/Project.module.css
// module id = 137
// module chunks = 35783957827783 213720915766396